// extracted by mini-css-extract-plugin
module.exports = {"closeModalButton":"CloseModalButton_closeModalButton__nJTUc","closeModalButtonIcon":"CloseModalButton_closeModalButtonIcon__NFGJG"};